module.exports = {"categories":{"tools":"Suunnittele hyödyllisiä työkaluja"},"carte":{"lDesc":"Luo omia karttojasi verkossa."}};